<section class="reaction-list">
  <ng-container *ngFor="let reaction of reactions">
    <button
      tuiButton
      class="button"
      type="button"
      [style.border-radius.rem]="0.75"
      [appearance]="reaction.containsMy ? 'reaction-self' : 'reaction-other'"
      [size]="'xs'"
      (click)="reaction.emodjiName && reactionClicked.emit(reaction.emodjiName)"
    >
      <app-emoji [emojiName]="reaction.emodjiName" [size]="18"></app-emoji>
      {{ reaction.emodjiCount }}
    </button>
  </ng-container>
</section>
